import { createAction, props } from '@ngrx/store';
import { BannerMessage } from '../banners.model';

export const getBanners = createAction('[Banners]: Get banners');

export const getBannersSuccess = createAction(
    '[Banners]: Get banners stops success',
    props<{ banners: BannerMessage[] }>()
);
